var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center gap-2 font-medium"},[(_vm.icon)?_c('FontAwesomeIcon',{attrs:{"icon":['far', _vm.icon]}}):_vm._e(),_c('span',{staticClass:"text-lg"},[_vm._t("default")],2),_c('div',{staticClass:"flex flex-row flex-wrap gap-2 ml-auto mr-0"},[_vm._t("right")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }